import { useParams } from "react-router-dom";
import Select from "react-select";
import { Submit } from "../../Components/Button";
import arrowLeftGreen from "../../assets/arrowLeftGreen.svg";
import BSModalView from "../Component/modal/bsModalView";
import { getPrepareConsole, getProjects } from "./services/apiHandler";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { consoleNotesData, filterOptionsData } from "./services/mockHandler";
import { fetchGroupData } from "../../redux/actions/actionGrouping";
import { fetchBSData, fetchBSDataClean } from "../../redux/actions/actionBS";
import { fetchPNLData } from "../../redux/actions/actionPNL";
import { fetchSocieData } from "../../redux/actions/actionSocie";
import { getAllIR, getCompany } from "../../WorkSpace/Components/ApiServices/apiHandler";
import { fetchPCData } from "../../redux/actions/actionPreset";
import { CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router";
import { fetchAssociateData } from "../../redux/actions/actionAssociate";
import { Navbar } from "../../Components/Navbar";
import { fetchSubsidiaryConsoleData } from "../../redux/actions/actionSubsidiaryData";




import Sidebar from "../../myfin_v2/elements/Sidebar";
import workSpaceCss from "../../myfin_v2/css/workSpaceOverView.module.css"
import ConsoleSideMenu from "../../myfin_v2/components/console/ConsoleSideMenu";
import ConsoleTopBar from "../../myfin_v2/components/console/ConsoleTopBar";

// import { ReactComponent as DeleteIcon} from "../../myfin_v2/assets/icons/delete_icon_primary.svg";
import Modal from "../../../src/myfin_v2/elements/Modal";
import modalcss from "../../../src/myfin_v2/css/modal.module.css";
import { ReactComponent as DeleteIconWhite } from "../../myfin_v2/assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
// import  { useState, useEffect, useContext } from "react";
import buttoncss from "../../myfin_v2/css/button.module.css";
import { Button } from "../../myfin_v2/elements/Button";
import { set } from "react-hook-form";
import swal from "sweetalert";
import { softDeleteNotesData } from "../../services/api/apiHandler";
import { socket } from "../../services/socket/socket";

import { motion } from "framer-motion";
import commoncss from "../../myfin_v2/css/common.module.css"
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css"
import { clearSoftDeleteNotes } from "../../redux/actions/TemplateTabs/actionDN";
import CustomTable from "./CustomTable/CustomTable";

const header = {
  height: "80px",
  width: "100%",
  backgroundColor: "white",
  display: "flex",
  alignItems: "center",
  padding: "0rem 1rem",
  borderRadius: "3px",
  marginBottom: "3rem",
  marginTop: "40px",
};
const name = {
  fontSize: "15px",
  fontWeight: "500",
  paddingLeft: "1%",
  paddingRight: "2%",
};
const button = {
  padding: "8px",
  width: "10rem",
  // marginLeft:'auto'
};
const button3 = {
  padding: "8px",
  width: "15rem",
  marginLeft: "283px",
};
const button2 = {
  padding: "8px",
  width: "15em",
  marginLeft: "auto",
};
const backNav = {
  fontSize: "1.2rem",
  fontWeight: "600",
  color: "#03565A",
  cursor: "pointer",
};

const mainTag = {
  fontSize: "1.15rem",
  fontWeight: "700",
};
const line = {
  height: "70%",
  width: "2px",
  backgroundColor: "rgb(229, 229, 229)",
  marginRight: "2%",
};
const ViewFS = (props) => {
  const id = useParams();
  const [consoldata, setConsolData] = useState("");
  const [projectPreset, setProjectPreset] = useState(null);
  const [projectsData, setProjectsData] = useState([]);
  const [allcheckdata, setConsolidate] = useState([]);
  const [allAssociateCheckData, setAssociateConsolidate] = useState([]);


  const [selectedPresetProject, setSelectedPresetProject] = useState(null);
  //   const AllCheckData = useSelector((state) => state.APAReducer);
  const [filterData, setFilterData] = useState([]);
  const [notes, setNotes] = useState([]);
  const balanceSheet = useSelector((state) => state.BSReducer);
  const pnlStatement = useSelector((state) => state.PNLReducer);
  const associateStatement = useSelector((state) => state.ASSOCIATEReducer);
  const getSocie = useSelector((state) => state.SoccieReducer);
  const groupingData = useSelector((state) => state.GroupingReducer);
  const subsidiaryData = useSelector((state) => state.SubsidiaryConsoleReducer);
  const dispatch = useDispatch();
  const currentCompProjectId = selectedPresetProject?.project_id ? selectedPresetProject?.project_id : projectPreset;
  const [allIrList, setAllIr] = useState([]);
  const [allCompany, setAllCompany] = useState([]);
  // const fetchPrepareConsole = useSelector((state) => state.PCReducer);
  const [activeTab, setActiveTab] = useState(0);

  let history = useHistory();
  useEffect(() => {
    // dispatch(fetchPCData(id.id));
    AllIrData();
    fetchPreConsole();
    getCompanyData();
    GetCompany();
  }, []);

  const AllIrData = async () => {
    const res = await getAllIR();
    if (res.status === 200) {
      setAllIr(res.data.fetchIR);
    }
  };
  const GetCompany = async () => {
    const res = await getCompany();
    if (res?.status === 200) {
      setAllCompany(res.data.getCompany);
    }
  };
  const FindIr = (ir_id) => {
    const IrData = allIrList.filter((data) => data._id === ir_id);
    return IrData;
  };

  useEffect(() => {
    (async () => {
      if (allcheckdata && allIrList) {
        if (filterData.length === 0) {
          const filter_res = await filterOptionsData();
          setFilterData(filter_res.data);
        }
        if (notes.length === 0) {
          const notes_data = await consoleNotesData();
          setNotes(notes_data.data);
        }
        if ((subsidiaryData && subsidiaryData.isSuccess)) {
          console.log("allcheckdata", allcheckdata);

          const project_ids = allcheckdata?.map((data) => data.project_id);
          const browse_fs_ids = subsidiaryData?.response?.otherData?.map((data) => data.prepare_preset_project_id);
          if (
            !groupingData.isSuccess ||
            groupingData.set_payload !==
            JSON.stringify({
              project_ids,
              browse_fs_ids,
              currentCompProjectId,
            })
          ) {
            dispatch(
              fetchGroupData(project_ids, browse_fs_ids, currentCompProjectId)
            );
          }
          if (
            !balanceSheet.isSuccess ||
            balanceSheet.set_payload !==
            JSON.stringify({
              project_ids,
              browse_fs_ids,
              currentCompProjectId,
            })
          ) {
            dispatch(
              fetchBSData(project_ids, browse_fs_ids, currentCompProjectId)
            );
          }
          if (
            !pnlStatement.isSuccess ||
            pnlStatement.set_payload !==
            JSON.stringify({
              project_ids,
              browse_fs_ids,
              currentCompProjectId,
            })
          ) {
            dispatch(
              fetchPNLData(project_ids, browse_fs_ids, currentCompProjectId)
            );
          }
          console.log("project_ids", project_ids);

          const payload = {
            project_ids: project_ids,
            browse_fs_ids: browse_fs_ids,
            current_comp_project_id: currentCompProjectId,
          };
          if (
            !getSocie.isSuccess ||
            getSocie.payload !== JSON.stringify(payload)
          ) {
            dispatch(fetchSocieData(payload));
          }
        }

        if (allAssociateCheckData.length > 0) {
          const project_ids = allAssociateCheckData.map((data) => data.project_id);
          const browse_fs = allAssociateCheckData.map((data) => FindIr(data.Ir_id));
          const browse_fs_ids = browse_fs.map(
            (data) => data[0]?.browse_control_dateFS
          );
          if (
            !associateStatement.isSuccess ||
            associateStatement.set_payload !==
            JSON.stringify({
              project_ids,
              browse_fs_ids,
              currentCompProjectId,
            })
          ) {
            dispatch(
              fetchAssociateData(project_ids, browse_fs_ids, currentCompProjectId)
            );
          }
        }
      }
    })();
  }, [allcheckdata, allIrList, subsidiaryData]);

  useEffect(() => {
    if (projectPreset) {
      getProjectName(projectPreset);
    }
  }, [projectPreset, projectsData]);

  const getCompanyData = async () => {
    try {
      const response = await getProjects();
      setProjectsData(response.data.project);
    } catch (err) {
      console.log("err", err.response);
    }
  };

  const getProjectName = async (p_id) => {
    try {
      const project = projectsData.find((data) => data._id === p_id);
      setSelectedPresetProject({
        project_name: project?.project_name,
        project_id: project?._id,
      });
    } catch (error) {
      console.log("error", error.message);
      return "None";
    }
  };
  const fetchPreConsole = async () => {
    try {
      const response = await getPrepareConsole(id.id);
      if (response.status === 200) {
        dispatch(fetchPCData(id.id))
        setConsolData(response.data.getOnePreCompany[0]);
        setProjectPreset(response.data.getOnePreCompany[0]?.upload_preset);
        setAssociateConsolidate(response?.data?.getOnePreCompany[0]?.AssociateConsolidate);
        setConsolidate(response.data.getOnePreCompany[0]?.consolidation);
        if (subsidiaryData.set_payload !== response.data.getOnePreCompany[0].link_company) {
          dispatch(fetchSubsidiaryConsoleData(response.data.getOnePreCompany[0].link_company));
        }
      }
    } catch (err) {
      console.log("err", err.response);
    }
  };

  const PopulateFS = () => {
    history.push(`/populate-fs/${id.id}`);
    window.location.reload();

  }

  const CompanyName = (c_id, field) => {
    const result = allCompany.filter((adj) => adj._id === c_id);
    if (field === "parent") {
      return result[0]?.company_name ? result[0]?.company_name : "-";
    } else {
      return result[0]?.company_name ? result[0]?.company_name : "-";
    }
  };

  const menuItems = [
    { label: "Balance Sheet", value: "Balance Sheets" },
    { label: "P&L Statement", value: "P&L Statement" },
    { label: "SOCIE", value: "SOCIE" },
    { label: "CashFlow", value: "CashFlow" },
    { label: "Balance Sheet Notes", value: "Balance Sheet Notes" },
    { label: "PNL Statement Notes", value: "PNL Statement Notes" },
    { label: "Adjustments", value: "Adjustments" },
  ];
  const [bsNotesSubmenu, setBSNotesSubmenu] = useState([]);
  const [bsNotesVal, setBSNotesVal] = useState(2);

  const adjustmentMenuItems = [
    { label: "Inter company eliminations", value: "Inter company eliminations" }
  ]

  const tableData = [
    {
      _id: "6948d5a4a0e7e56d54dd013c",
      date:"March 2025",
      particular: "Employee stock options",
      _lineType: "lineItem",
      companies: [{
        _id:"aaido",
        title: "Company A",
        "FY-2": 5,
        PY: 189000,
        CY: 329000,
      },
      {
        _id:"aaido",
        title: "Company B",
        "FY-2": 2,
        PY: 269000,
        CY: 699000,
      }],
      reference: "B",
    }, {
      _id: "6948d5a4a0e7e56d54dd013c",
      date:"March 2025",
      particular: "Employee stock options",
      _lineType: "lineItem",
      companies: [{
        _id:"aaido",
        title: "Company A",
        "FY-2": 5,
        PY: 589000,
        CY: 228000,
      },
      {
        _id:"aaido",
        title: "Company B",
        "FY-2": 2,
        PY: 600000,
        CY: 980000,
      }],
      reference: "A",

    }, {
      _id: "6948d5a4a0e7e56d54dd013c",
      date:"March 2025",
      particular: "Employee stock options",
      _lineType: "lineItem",
      companies: [{
        _id:"aaido",
        title: "Company A",
        "FY-2": 5,
        PY: 689000,
        CY: 290000,
      },
      {
        _id:"aaido",
        title: "Company B",
        "FY-2": 2,
        PY: 600000,
        CY: 900000,
      }],
      reference: "A",

    }, {
      _id: "6948d5a4a0e7e56d54dd013c",
      date:"March 2025",
      particular: "Transfer to retained earnings",
      _lineType: "lineItem",
      companies: [{
        _id:"aaido",
        title: "Company A",
        "FY-2": 5,
        PY: 189000,
        CY: 220000,
      },
      {
        _id:"aaido",
        title: "Company B",
        "FY-2": 2,
        PY: 600000,
        CY: 900000,
      }],
      reference: "A",

    }
  ];

  return (
    <>

      <div className={`${workSpaceCss.df}`} >
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <ConsoleSideMenu title="Consol FS" menuItems={menuItems} activeItem={activeTab} setActiveTab={setActiveTab} bsNotesSubmenu={bsNotesSubmenu} setBSNotesVal={setBSNotesVal} adjustmentMenuItems={adjustmentMenuItems} />
          </motion.div>
          <div className={bookclosurecss.bookClosureContent} style={{ "overflow-x": "hidden" }}>
            {activeTab != 6 && (
              <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
                <ConsoleTopBar history={history} />
              </div>
            )}
            <div style={activeTab !== 6 ? { height: "88vh", overflow: "auto" } : { overflow: "auto", height: "100vh" }}>

              {/* <CustomTable rows={tableData} /> */}

              {balanceSheet.loading ? (
                <CircularProgress disableShrink />
              ) : balanceSheet.isSuccess ? (
                <div>
                  {balanceSheet.isSuccess ? (
                    <BSModalView
                      setBSNotesSubmenu={setBSNotesSubmenu}
                      activeTab={activeTab}
                      balanceSheetData={balanceSheet}
                      pnlStatementData={pnlStatement}
                      groupingData={groupingData}
                      filterData={filterData}
                      consoleData={consoldata}
                      allcheckdata={allcheckdata}
                      currentCompProjectId={currentCompProjectId}
                      consoleNotes={notes}
                      id={id.id}
                      allIrListdata={allIrList}
                      allAssociateCheckData={allAssociateCheckData}
                      associateStatement={associateStatement}
                      CompanyName={CompanyName}
                      FindIr={FindIr}
                    />
                  ) : (
                    "-------"
                  )}
                </div>
              ) : (
                <p className="text-danger">{balanceSheet.error_message}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewFS;
